import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  href: "#main-content",
  class: "govuk-skip-link"
}, "Skip to main content", -1)
const _hoisted_2 = {
  class: "govuk-header",
  role: "banner",
  "data-module": "govuk-header"
}
const _hoisted_3 = { class: "govuk-header__container govuk-width-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "govuk-header__logo" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://gov.uk",
    class: "govuk-header__link govuk-header__link--homepage"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "govuk-header__logotype" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        "aria-hidden": "true",
        focusable: "false",
        class: "govuk-header__logotype-crown",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 132 97",
        height: "30",
        width: "36"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d: "M25 30.2c3.5 1.5 7.7-.2 9.1-3.7 1.5-3.6-.2-7.8-3.9-9.2-3.6-1.4-7.6.3-9.1 3.9-1.4 3.5.3 7.5 3.9 9zM9 39.5c3.6 1.5 7.8-.2 9.2-3.7 1.5-3.6-.2-7.8-3.9-9.1-3.6-1.5-7.6.2-9.1 3.8-1.4 3.5.3 7.5 3.8 9zM4.4 57.2c3.5 1.5 7.7-.2 9.1-3.8 1.5-3.6-.2-7.7-3.9-9.1-3.5-1.5-7.6.3-9.1 3.8-1.4 3.5.3 7.6 3.9 9.1zm38.3-21.4c3.5 1.5 7.7-.2 9.1-3.8 1.5-3.6-.2-7.7-3.9-9.1-3.6-1.5-7.6.3-9.1 3.8-1.3 3.6.4 7.7 3.9 9.1zm64.4-5.6c-3.6 1.5-7.8-.2-9.1-3.7-1.5-3.6.2-7.8 3.8-9.2 3.6-1.4 7.7.3 9.2 3.9 1.3 3.5-.4 7.5-3.9 9zm15.9 9.3c-3.6 1.5-7.7-.2-9.1-3.7-1.5-3.6.2-7.8 3.7-9.1 3.6-1.5 7.7.2 9.2 3.8 1.5 3.5-.3 7.5-3.8 9zm4.7 17.7c-3.6 1.5-7.8-.2-9.2-3.8-1.5-3.6.2-7.7 3.9-9.1 3.6-1.5 7.7.3 9.2 3.8 1.3 3.5-.4 7.6-3.9 9.1zM89.3 35.8c-3.6 1.5-7.8-.2-9.2-3.8-1.4-3.6.2-7.7 3.9-9.1 3.6-1.5 7.7.3 9.2 3.8 1.4 3.6-.3 7.7-3.9 9.1zM69.7 17.7l8.9 4.7V9.3l-8.9 2.8c-.2-.3-.5-.6-.9-.9L72.4 0H59.6l3.5 11.2c-.3.3-.6.5-.9.9l-8.8-2.8v13.1l8.8-4.7c.3.3.6.7.9.9l-5 15.4v.1c-.2.8-.4 1.6-.4 2.4 0 4.1 3.1 7.5 7 8.1h.2c.3 0 .7.1 1 .1.4 0 .7 0 1-.1h.2c4-.6 7.1-4.1 7.1-8.1 0-.8-.1-1.7-.4-2.4V34l-5.1-15.4c.4-.2.7-.6 1-.9zM66 92.8c16.9 0 32.8 1.1 47.1 3.2 4-16.9 8.9-26.7 14-33.5l-9.6-3.4c1 4.9 1.1 7.2 0 10.2-1.5-1.4-3-4.3-4.2-8.7L108.6 76c2.8-2 5-3.2 7.5-3.3-4.4 9.4-10 11.9-13.6 11.2-4.3-.8-6.3-4.6-5.6-7.9 1-4.7 5.7-5.9 8-.5 4.3-8.7-3-11.4-7.6-8.8 7.1-7.2 7.9-13.5 2.1-21.1-8 6.1-8.1 12.3-4.5 20.8-4.7-5.4-12.1-2.5-9.5 6.2 3.4-5.2 7.9-2 7.2 3.1-.6 4.3-6.4 7.8-13.5 7.2-10.3-.9-10.9-8-11.2-13.8 2.5-.5 7.1 1.8 11 7.3L80.2 60c-4.1 4.4-8 5.3-12.3 5.4 1.4-4.4 8-11.6 8-11.6H55.5s6.4 7.2 7.9 11.6c-4.2-.1-8-1-12.3-5.4l1.4 16.4c3.9-5.5 8.5-7.7 10.9-7.3-.3 5.8-.9 12.8-11.1 13.8-7.2.6-12.9-2.9-13.5-7.2-.7-5 3.8-8.3 7.1-3.1 2.7-8.7-4.6-11.6-9.4-6.2 3.7-8.5 3.6-14.7-4.6-20.8-5.8 7.6-5 13.9 2.2 21.1-4.7-2.6-11.9.1-7.7 8.8 2.3-5.5 7.1-4.2 8.1.5.7 3.3-1.3 7.1-5.7 7.9-3.5.7-9-1.8-13.5-11.2 2.5.1 4.7 1.3 7.5 3.3l-4.7-15.4c-1.2 4.4-2.7 7.2-4.3 8.7-1.1-3-.9-5.3 0-10.2l-9.5 3.4c5 6.9 9.9 16.7 14 33.5 14.8-2.1 30.8-3.2 47.7-3.2z"
        })
      ]),
      /*#__PURE__*/_createElementVNode("span", { class: "govuk-header__logotype-text" }, " GOV.UK ")
    ])
  ])
], -1)
const _hoisted_5 = { class: "govuk-header__content" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Find a will ")
const _hoisted_7 = ["aria-expanded"]
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = ["href", "onClick"]
const _hoisted_10 = {
  key: 0,
  class: "govuk-header__navigation-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: { name: 'Home' },
            class: "govuk-header__link govuk-header__link--service-name"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuVisible = !_ctx.isMenuVisible)),
            type: "button",
            class: "govuk-header__menu-button govuk-js-header-toggle",
            "aria-controls": "navigation",
            "aria-label": "Show or hide navigation menu",
            "aria-expanded": _ctx.isMenuVisible
          }, "Menu", 8, _hoisted_7),
          _createElementVNode("nav", null, [
            _createElementVNode("ul", {
              id: "navigation",
              class: _normalizeClass(_ctx.menuClassList),
              "aria-label": "Navigation menu"
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'Home', params: { clearSearch: 'true' } },
                custom: ""
              }, {
                default: _withCtx(({ href, navigate, isExactActive }) => [
                  _createElementVNode("li", {
                    class: _normalizeClass({ 'govuk-header__navigation-item': true, 'govuk-header__navigation-item--active': isExactActive })
                  }, [
                    _createElementVNode("a", {
                      class: "govuk-header__link",
                      href: href,
                      onClick: navigate
                    }, "New Search", 8, _hoisted_8)
                  ], 2)
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: index,
                  to: { name: item.name },
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate, isExactActive }) => [
                    _createElementVNode("li", {
                      class: _normalizeClass({ 'govuk-header__navigation-item': true, 'govuk-header__navigation-item--active': isExactActive })
                    }, [
                      _createElementVNode("a", {
                        class: "govuk-header__link",
                        href: href,
                        onClick: navigate
                      }, _toDisplayString(item.text), 9, _hoisted_9)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128)),
              (_ctx.isAuthenticated)
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createElementVNode("a", {
                      class: "govuk-header__link",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)), ["prevent"])),
                      href: "#"
                    }, "Logout")
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ])
      ])
    ])
  ], 64))
}